var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"filled":"","label":_vm.itemLabel,"disabled":""},on:{"blur":function($event){return _vm.$emit('blur', _vm.theValue)}},model:{value:(_vm.theValue),callback:function ($$v) {_vm.theValue=$$v},expression:"theValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }